import React, { useEffect, useState } from 'react'
import { formatePhoneNumber } from '../../../utils/helpers';

const Participant = ({ participants, setParticipantModal }) => {
    const activeMembers = participants.filter(p => p.status === 'add');
    const pastMembers = participants.filter(p => p.status === 'remove');

    return (
        <div className='participants'>
            <div className="header">
                <button className="back-btn">
                    <img src="/arrow.png" alt="" onClick={() => setParticipantModal(false)}/>
                </button>
                <h4 className="participants-title">Group Info</h4>
            </div>
            <hr />
            <div className='participants-list'>
            <p className='active-members'>{activeMembers.length} Members</p>
            {activeMembers.map((p, i) => (
                <div key={i} className='participant-item'>
                    <span className='participant-name'>
                    {formatePhoneNumber(p.participant_jid, false)}
                    </span>
                    {p.is_superadmin ? (
                    <span className='badge superadmin'>Owner</span>
                    ) : p.is_admin ? (
                    <span className='badge admin'>Group Admin</span>
                    ) : null}
                </div>
                ))}
            </div>
            {pastMembers.length > 0 && (
                <>
                    <p className='past-members'>Past Members</p>
                    <div className='participants-list'>
                        {pastMembers.map((p, i) => (
                        <div key={i} className='participant-item'>
                            <span className='participant-name'>
                            {formatePhoneNumber(p.participant_jid, false)}
                            </span>
                        </div>
                        ))}
                    </div>
                </>
            )}
        </div>
    )
}

export default Participant;
